import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";
import { NewMessage } from "../types/NewMessage";

export const useCreateMessage = (onSuccess: () => void, onError: (error: string) => void) => {

    const { mutate, isLoading } = useMutation({
        mutationFn: async (params: NewMessage) => {
            return await apiClient.post("communication/message", params) as ApiResult;
        },
        onSuccess: async (result) => {
            if (result.isSuccess)
                onSuccess();
            else
                onError('Error when creating the message: ' + result.errorMessage!);
        },
        onError(error) {
            onError(error as string);
        }
    });

    return {
        mutate, isLoading
    }
}
